import { useFeatureFlag } from 'v2/core/clients/featureFlag';
import { FeatureFlagType } from 'v2/core/clients/featureFlag/flags';

const supportAllFormulasFeatureFlag: FeatureFlagType = {
  name: 'support-all-formulas',
  fallback: false,
};

export function useShouldSupportAllFormulas() {
  const [, shouldSupportAllFormulas] = useFeatureFlag(
    supportAllFormulasFeatureFlag,
  );

  return shouldSupportAllFormulas;
}
